export var EPercentVisible;

(function (EPercentVisible) {
  EPercentVisible[EPercentVisible["Percent100"] = 1] = "Percent100";
  EPercentVisible[EPercentVisible["Percent90"] = 0.9] = "Percent90";
  EPercentVisible[EPercentVisible["Percent80"] = 0.8] = "Percent80";
  EPercentVisible[EPercentVisible["Percent70"] = 0.7] = "Percent70";
  EPercentVisible[EPercentVisible["Percent60"] = 0.6] = "Percent60";
  EPercentVisible[EPercentVisible["Percent50"] = 0.5] = "Percent50";
  EPercentVisible[EPercentVisible["Percent40"] = 0.4] = "Percent40";
  EPercentVisible[EPercentVisible["Percent30"] = 0.3] = "Percent30";
  EPercentVisible[EPercentVisible["Percent20"] = 0.2] = "Percent20";
  EPercentVisible[EPercentVisible["Percent10"] = 0.1] = "Percent10";
})(EPercentVisible || (EPercentVisible = {}));